<div class="footer">
  <div class="footerText">&#169; {{currentYear}} EYGM Limited | All Rights Reserved.</div>
      <!-- <div class="footerText">
        Data from Retain is refreshed daily after 3.30am. Bookings will be refreshed in the tool for every 3 hours in a day.
        <span *ngIf = "isUserLoggedIn"> 
        Last Refresh Date/Time: {{modifiedDate | date: 'dd-MM-y h:mm a'}} {{TimeZone}}
      </span>
    </div> -->
</div>
